import {useMutation, useQueryClient} from "@tanstack/react-query";
import {useCommonItems} from "../../../../../contexts/CommonItensProvider";
import {useForm} from "react-hook-form";
import {manipulaSistema} from "../../configs/functions";
import {fillInputErrors, getFormErrorMessage} from "../../../../../configs/functions";
import {useEffect} from "react";
import {Box, Dialog, DialogContent, DialogContentText, DialogTitle, FormControl, Grid, TextField} from "@mui/material";
import {CommonDialogActionsForm} from "../../../../common/CommonDialogActionsForm";


export function SystemForm({ open, setOpen, system, queryKey }) {
    const queryClient = useQueryClient();
    const { exibirAlerta } = useCommonItems();

    const isEditAction = !!system;
    const {
        register,
        handleSubmit,
        setError,
        reset,
        formState: { dirtyFields, errors, isSubmitting },
    } = useForm();

    const { mutateAsync: manipulaSistemaFn } = useMutation({
        mutationFn: (data) => manipulaSistema(data, isEditAction),
    })

    async function handleFormSubmit(data) {
        try {
            let formatData = {};

            if (isEditAction) {
                const dirtyFieldKeys = Object.keys(dirtyFields);

                const dirtyData = dirtyFieldKeys.reduce((acc, key) => {
                    if (data.hasOwnProperty(key)) {
                        acc[key] = data[key];
                    }
                    return acc;
                }, {});

                if (Object.keys(dirtyData).length === 0) {
                    exibirAlerta('Atenção', 'Nenhum dado foi alterado.', 'warning');
                    return;
                }

                formatData = dirtyData;
                formatData.id = system.id;
            } else {
                delete data.id;
                formatData = data;
            }

            const response = await manipulaSistemaFn(formatData);
            if (!response) throw new Error('Erro ao cadastrar Módulo.');

            queryClient.invalidateQueries({ queryKey });

            exibirAlerta('Sucesso', response.data.message, 'success');
            setOpen(false);
        } catch (error) {
            let errorMessage = isEditAction ? 'Erro ao editar Sistema.' : 'Erro ao cadastrar Sistema.';
            if (error.response) {
                errorMessage = error.response.data.error || error.response.data.message;
                fillInputErrors(error, setError);
            }
            exibirAlerta('Erro', errorMessage, 'error');
        }
    }

    useEffect(() => {
        if (open) {
            const defaultValues = {
                id: system ? system.id : '',
                nome: system ? system.nome : '',
                descricao: system ? system.descricao : '',
            };

            reset(defaultValues);
        } else {
            reset();
        }
    }, [system, open, reset]);

    return (
        <Dialog open={open} fullWidth maxWidth={"md"}>
            <form onSubmit={handleSubmit(handleFormSubmit)}>
                {isEditAction
                    ? <DialogTitle>Editando Sistema: <strong>{system.nome}</strong></DialogTitle>
                    : <DialogTitle>Cadastrando novo Sistema</DialogTitle>
                }
                <DialogContent>
                    <DialogContentText sx={{ mb: 2 }}>Preencha corretamente os dados</DialogContentText>
                </DialogContent>

                <DialogContent>
                    <Box sx={{ p: 2, backgroundColor: "#fafafa" }} >
                        <FormControl variant="standard" fullWidth>
                            <Grid
                                container
                                direction="row"
                                justifyContent="flex-start"
                                alignItems="flex-start"
                                spacing={2}
                            >
                                <Grid item xs={12} md={12}>
                                    <TextField
                                        autoFocus
                                        InputLabelProps={{ shrink: true }}
                                        margin='dense'
                                        label='Nome'
                                        placeholder='Digite o Nome do Sistema'
                                        fullWidth
                                        {...register("nome", { required: true })}
                                        error={!!errors.nome}
                                        helperText={getFormErrorMessage(errors, 'nome')}
                                        variant="outlined"
                                        autoComplete='off'
                                        inputProps={{ form: { autoComplete: 'off' } }}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <TextField
                                        InputLabelProps={{ shrink: true }}
                                        margin='dense'
                                        label='Descrição'
                                        placeholder='Digite a Descrição'
                                        name='descricao'
                                        fullWidth
                                        {...register("descricao", { required: false })}
                                        variant="outlined"
                                        multiline
                                        rows={3}
                                        error={!!errors.descricao}
                                        helperText={getFormErrorMessage(errors, 'descricao')}
                                    />
                                </Grid>
                            </Grid>
                        </FormControl>
                    </Box>
                </DialogContent>

                <CommonDialogActionsForm errors={errors} isLoading={isSubmitting} setOpen={setOpen} />
            </form>
        </Dialog>
    );
}